import { render } from "./SetupMFA.vue?vue&type=template&id=3cd02159&scoped=true"
import script from "./SetupMFA.vue?vue&type=script&lang=js"
export * from "./SetupMFA.vue?vue&type=script&lang=js"

import "./SetupMFA.vue?vue&type=style&index=0&id=3cd02159&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd02159"]])

export default __exports__